import React, { useState } from 'react';

import { Header } from '../../../components/singleComponents/headers';

import { Description } from './components/Description';
import { KeyWords } from './components/KeyWords';
import { Questions } from './components/Questions';

import { RootStyled } from './faqAdmin.styles';

export function FaqAdmin() {
  const [keyWord, setKeyWord] = useState('');

  return (
    <>
      <Header page="Faq" />
      <RootStyled>
        <Description />
        <KeyWords keyWord={keyWord} setKeyWord={setKeyWord} />
        <Questions keyWord={keyWord} />
      </RootStyled>
    </>
  );
}
